export default __webpack_public_path__ + "static/media/leverkusen_dark.73efa325.png";